<template>
  <div>
    <h1 v-if="isAddNewPosition">新增職位與權限</h1>
    <h1 v-else>權限管理</h1>
    <section class="bottom-space-10">
      <Button type="primary" @click="AddNewPosition">
        <Icon type="md-add"/>職位
      </Button>
    </section>
    <section class="bottom-space-50">
      <h2>職位</h2>
      <div v-if="isAddNewPosition">
        <Input v-model="newPosition" placeholder="請輸入職位名稱" size="large" style="width: 300px"></Input>
      </div>
      <div v-else>
        <Select v-model="selectedPositionID" size="large" style="width:300px" @on-change="showCheckbox" placeholder="請選擇">
          <Option v-for="item in positionOptions" :value="item.id" :key="item.id">{{ item.positionName }}</Option>
        </Select>
      </div>
    </section>
    <section class="bottom-space-30">
      <h2>權限</h2>
      <div class="checkbox-container">
        <div class="checkbox-type" v-if="isAddNewPosition">
          <Checkbox v-model="authorizations.isAddEmployee" size="large">新增員工</Checkbox>
          <Checkbox v-model="authorizations.isEditEmployee" size="large">編輯員工資料/員工密碼</Checkbox>
          <Checkbox v-model="authorizations.isSealEmployee" size="large">刪除員工</Checkbox>
        </div>
        <div class="checkbox-type" v-else>
          <Checkbox v-model="getPositionAuthorizations.isAddEmployee" size="large">新增員工</Checkbox>
          <Checkbox v-model="getPositionAuthorizations.isEditEmployee" size="large">編輯員工資料/員工密碼</Checkbox>
          <Checkbox v-model="getPositionAuthorizations.isSealEmployee" size="large">刪除員工</Checkbox>
        </div>
        <div class="checkbox-type" v-if="isAddNewPosition">
          <Checkbox v-model="authorizations.isEditSigning" size="large">編輯企業簽單</Checkbox>
        </div>
        <div class="checkbox-type" v-else>
          <Checkbox v-model="getPositionAuthorizations.isEditSigning" size="large">編輯企業簽單</Checkbox>
        </div>
        <div class="checkbox-type" v-if="isAddNewPosition">
          <Checkbox v-model="authorizations.isAddManager" size="large">新增管理者</Checkbox>
          <Checkbox v-model="authorizations.isEditManagerPassword" size="large">修改所有管理者密碼</Checkbox>
          <Checkbox v-model="authorizations.isSealManager" size="large">刪除管理者</Checkbox>
        </div>
        <div class="checkbox-type" v-else>
          <Checkbox v-model="getPositionAuthorizations.isAddManager" size="large">新增管理者</Checkbox>
          <Checkbox v-model="getPositionAuthorizations.isEditManagerPassword" size="large">修改所有管理者密碼</Checkbox>
          <Checkbox v-model="getPositionAuthorizations.isSealManager" size="large">刪除管理者</Checkbox>
        </div>
      </div>
    </section>
    <section class="button-container">
      <div v-if="isAddNewPosition">
        <Button type="success" @click="submitNewPosition">送出</Button>
        <Button @click="cancelNewPosition">取消</Button>
      </div>
      <div v-else>
        <Button type="info" @click="renewPositionAuthorizations">更新</Button>
        <Button type="error" @click="removePositionAuthorizations">刪除</Button>
      </div>
    </section>



  </div>
</template>

<script>
// import { webServer } from "@/utilities/api"
import API from "../asset/js/API"

import jsCookie from 'js-cookie'
import { mappingToBackendKey, mappingToFrotendKey } from '@/mapping.js'

export default {
  created () {
    // webServer.defaults.headers.common['x-access-token'] = jsCookie.get('token')
    this.getPositionList()
    this.getPositionAuthorizationsDrtail()

  },
  data () {
    return {
      isAddNewPosition: false,
      newPosition: '',
      positionOptions: [],
      selectedPositionID: 1,
      authorizations: {
        isAddEmployee: false,
        isEditEmployee: false,
        isSealEmployee: false,
        isEditSigning: false,
        isAddManager: false,
        isEditManagerPassword: false,
        isSealManager: false,
      },
      getPositionAuthorizations: {}
    }
  },
  methods: {
    getPositionList() {
      API.get(`/manager/position`)
      .then(res => {
        this.positionOptions = res.result.list
      })
      .catch(err => {
        console.error('職位列表',err)
      })
    },
    getPositionAuthorizationsDrtail() {
      API.get(`/position/${this.selectedPositionID}`)
      .then(res => {
        /******************************************
          get 的資料結構是
          {
            employee: {
              isAddEmployee: false,
              ...
            },
            manager: {...},
            signing: {...}
          }
          但 post 的資料結構是
          {
            isAddEmployee: false,
            ...
          }
          手動換成一維 object
        *******************************************/
        const transformData = {}
        Object.keys(res.result.employee).forEach(key => {
          //回傳的 data 裡有這裡用不到的 key，避免 Map.get undefined
          if( mappingToFrotendKey.get(key) ) {
            transformData[mappingToFrotendKey.get(key)] = res.result.employee[key]
          }
        })
        Object.keys(res.result.manager).forEach(key => {
          if( mappingToFrotendKey.get(key) ) {
            transformData[mappingToFrotendKey.get(key)] = res.result.manager[key]
          }
        })
        Object.keys(res.result.signing).forEach(key => {
          if( mappingToFrotendKey.get(key) ) {
            transformData[mappingToFrotendKey.get(key)] = res.result.signing[key]
          }
        })
        this.getPositionAuthorizations = JSON.parse(JSON.stringify(transformData))
        console.log(this.getPositionAuthorizations)
      })
      .catch(err => {
        console.error('職位詳細權限',err)
      })
    },
    AddNewPosition() {
      this.isAddNewPosition = true
    },
    submitNewPosition() {
      let postData = JSON.parse(JSON.stringify(this.authorizations))
      postData.positionName = this.newPosition
      API.post(`/position`, postData)
      .then(res => {
        this.$Message.info(res.result)
        this.getPositionList()
        this.isAddNewPosition = false
      })
      .catch(err => {
        console.error('新增職位權限',err)
        this.isAddNewPosition = false
      })

    },
    cancelNewPosition() {
      this.isAddNewPosition = false
    },
    showCheckbox() {
      this.getPositionAuthorizationsDrtail()
    },
    renewPositionAuthorizations() {
      API.put(`/position/${this.selectedPositionID}`,this.getPositionAuthorizations)
      .then(res => {
        this.$Message.info(res.result)
        this.getPositionList()
        console.log('更新職位權限',res.result)
      })
      .catch(err => {
        this.$Message.info(err)
        console.error('更新職位權限',err)
      })
    },
    removePositionAuthorizations(){
      API.delete(`/position/${this.selectedPositionID}`,this.getPositionAuthorizations)
      .then(res => {
        this.$Message.info(res.result)
        this.getPositionList()
        console.log('更新職位權限',res.result)
      })
      .catch(err => {
        this.$Message.info(err)
        console.error('更新職位權限',err)
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/Authorization.scss";

</style>



// WEBPACK FOOTER //
// src/components/Authorization.vue